import React from 'react';
import CloseIcon from './CloseIcon';
import HamburguerMenuIcon from './Icons/HamburguerMenuIcon';

const NavigationMenu = ({ toggleMenu, menuIsOpen }) => {
  return (
    <button onClick={toggleMenu} aria-label="Open menu">
      {menuIsOpen ? <CloseIcon size="32px" /> : <HamburguerMenuIcon size={32} color="#1C1B1F" />}
    </button>
  );
};

export default NavigationMenu;
